<template>
  <div class="homePage">
    <home-banner ref="homeBanner" :height="535"></home-banner>
    <!-- hot -->
    <!-- 企业风采，头部新闻栏 -->

    <!-- <div class="TTouTiao">
      <div class="Tl"></div> -->
    <!-- <div class="Tr">
        <el-carousel direction="vertical" :interval="3000" indicator-position="none">
          <el-carousel-item v-for="(item, index) in newsTextList" :key="index">
            <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }} </a>
            <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
              {{ item.title }}
            </router-link>
          </el-carousel-item>
        </el-carousel>
      </div> -->
    <!-- </div> -->
    <!-- 新闻动态第一部分 -->
    <div class="Tpage Part1" id="part1">
      <div class="Newstop">
        <div class="Newstoptitle">
          <p>企业风采</p>
        </div>
        <div class="Newstopright">
          <div class="Newstopright1" v-for="(item, index) in nav1" :key="index">
            <a :href="item.url"
             :class="{ nav1OnCss: nav1On == index }"
              @mouseenter="addnav1Css(index)">{{ item.title }}</a>
          </div>
          <!-- <div class="Newstopright2">
            <a href="/list/0238"
              >建投要闻</a
            >
          </div> -->
        </div>
      </div>
      <!-- 新闻列表图片轮播图 -->
      <div class="NewsL">
        <div
          id="newsFlashItem"
          style="width: 585px; height: 375px; overflow: hidden"
        >
          <div class="flashImg" style="display: block">
            <div class="flashImg-container swiper-container" id="newsFlash">
              <div class="flashImg-wrapper swiper-wrapper">
                <div
                  class="flashImg-slide swiper-slide"
                  v-for="(item, index) in flashImgList11"
                  :key="index"
                >
                  <a
                    v-if="item.url && item.url !== ''"
                    :href="item.url"
                    target="_blank"
                  >
                    <img
                      class="swiper_img"
                      :src="item.thumb1"
                      style="width: 585px; height: 375px"
                    />
                    <!-- <div class="txt">
                      <p class="txtTitle">{{ item.title }}</p> 
                     </div> -->
                  </a>
                  <a
                    v-else
                    :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    target="_blank"
                  >
                    <img
                      class="swiper_img"
                      :src="item.thumb1"
                      style="width: 585px; height: 375px"
                    />
                    <!-- <div class="txt">
                      <p class="txtTitle">{{ item.title }}</p>
                    </div> -->
                  </a>
                </div>
              </div>
              <div class="swiper-pagination flashImg-pagin"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻内容列表第一部分 -->
      <div class="NewsR">
        <ul class="inList" v-if="nav1On == 0">
          <li v-for="(item, index) in newCatalogList01" :key="index">
            <div class="l_Date">
              <p class="topTxt">
                {{ dayjs(item.publishDate).format("MM-DD") }}
              </p>
              <p class="bottomTxt">
                {{ dayjs(item.publishDate).format("YYYY") }}
              </p>
            </div>
            <div class="r_news">
              <!-- <a :href="item.url" target="_blank">{{ item.title }}</a> -->
              <a
                v-if="item.url && item.url !== ''"
                :href="item.url"
                target="_blank"
                >{{ item.title }}</a
              >
              <router-link
                v-else
                target="_blank"
                :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                >{{ item.title }}
              </router-link>
            </div>
          </li>
          <!-- <li>
            <div class="l_Date">
              <p class="topTxt">12-13</p>
              <p class="bottomTxt">2023</p>
            </div>
            <div class="r_news">
              <a
                href="https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514360&amp;idx=1&amp;sn=9cb0052c1e386ed4e95b971e29da3bfd&amp;chksm=ec019f72db7616648b0c5a67ff7e0bab29bda338dc5bdf2fbc7c359c749c74f64d202a666e9a&amp;token=1734539789&amp;lang=zh_CN#rd"
                target="_blank"
                >【项目党建专栏】夯实堡垒聚合力 党建领航促发展——三公司推动党建...</a
              >
            </div>
          </li>
          <li>
            <div class="l_Date">
              <p class="topTxt">12-13</p>
              <p class="bottomTxt">2023</p>
            </div>
            <div class="r_news">
              <a
                href="https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514360&amp;idx=2&amp;sn=390bba69fdacd1a916d2fedcac39a515&amp;chksm=ec019f72db7616646ee4ec19025032170eb5bad9dedbb4ad006da772bca4ed1fe441860594df&amp;token=1734539789&amp;lang=zh_CN#rd"
                target="_blank"
                >【支部共建栏目】开讲啦！这场讲座干货满满</a
              >
            </div>
          </li>
          <li>
            <div class="l_Date">
              <p class="topTxt">12-11</p>
              <p class="bottomTxt">2023</p>
            </div>
            <div class="r_news">
              <a
                href="https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514211&amp;idx=1&amp;sn=cc7778ee9322ed25c4d56b31f8311281&amp;chksm=ec019fe9db7616ffbc3bd025376cb34a8b1a48fe0701b12e29ece259bb8f40d1432f12d7a8cf&amp;token=542266017&amp;lang=zh_CN#rd"
                target="_blank"
                >【宪法宣传栏目】大力弘扬宪法精神，建设社会主义法治文化——三公司...</a
              >
            </div>
          </li>
          <li>
            <div class="l_Date">
              <p class="topTxt">12-11</p>
              <p class="bottomTxt">2023</p>
            </div>
            <div class="r_news">
              <a
                href="https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514211&amp;idx=2&amp;sn=b9ea2aa2cae03f69cae470cb0f7f91b8&amp;chksm=ec019fe9db7616ff3dc173ea6296df8676e17d14112cdef97d015b41d2494dc9f55f2ca441db&amp;token=542266017&amp;lang=zh_CN#rd"
                target="_blank"
                >【宪法宣传栏目】弘扬宪法精神 维护宪法权威——盛久基业党支部开展...</a
              >
            </div>
          </li> -->
        </ul>
        <ul class="inList" v-if="nav1On == 1">
          <li v-for="(item, index) in jtNewsList" :key="index">
            <div class="l_Date">
              <p class="topTxt">
                {{ dayjs(item.publishDate).format("MM-DD") }}
              </p>
              <p class="bottomTxt">
                {{ dayjs(item.publishDate).format("YYYY") }}
              </p>
            </div>
            <div class="r_news">
              <!-- <a :href="item.url" target="_blank">{{ item.title }}</a> -->
              <a
                v-if="item.url && item.url !== ''"
                :href="item.url"
                target="_blank"
                >{{ item.title }}</a
              >
              <router-link
                v-else
                target="_blank"
                :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                >{{ item.title }}
              </router-link>
            </div>
          </li>
        </ul>
        <!-- <div class="Tit" id="NewsT">
          <div
            class="NewsRInner"
            :class="{ active: activeNewsJt == index }"
            v-for="(item, index) in catalogList"
            :key="index"
            @mouseenter="mouseenterNewsJt(index)"
          > -->
        <!-- mouseenter 鼠标进入事件，当鼠标进入时获取 catalogList 目录的index ， 将目录的index 的值赋给activeNewsJt -->
        <!-- v-if 进行判断，当index等于确定值时，显示新闻列表ul -->
        <!-- <a :href="item.url"
              >{{ item.title }}
              <img v-if="activeNewsJt == index" src="../assets/img/com_tit_b.png" />
            </a>
          </div>
        </div> -->
        <!-- <div class="ItemList">
          <div class="NewsItem">
            <ul class="comUl" v-if="activeNewsJt == 0">
              <li v-for="(item, index) in newCatalogList01" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
            <ul class="comUl" v-if="activeNewsJt == 1">
              <li v-for="(item, index) in newCatalogList02" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/yiji00020002/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
            <ul class="comUl" v-if="activeNewsJt == 2">
              <li v-for="(item, index) in newCatalogList03" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
            <ul class="comUl" v-if="activeNewsJt == 3">
              <li v-for="(item, index) in newCatalogList04" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div class="clear"></div> -->
    <!-- 工程业绩展示 -->
    <div class="Tpage Part6">
      <div class="tit">
        <div class="b">工程业绩</div>
        <a href="/listPic/0245" class="more">更多+</a>
      </div>
      <div class="main_panel" id="Jpgc">
        <div class="JpgcSwiper-container swiper-container" id="jpgcPhoto">
          <div class="JpgcSwiper-wrapper swiper-wrapper">
            <div
              class="JpgcSwiper-slide swiper-slide"
              v-for="(item, index) in JpgcPlayList"
              :key="index"
            >
              <a
                :href="item.url"
                v-if="item.url && item.url !== ''"
                class="JpItem"
                target="_blank"
              >
                <div class="img">
                  <img
                    class="swiper_img"
                    :src="item.thumb1"
                    style="width: 100%"
                  />
                </div>
                <div class="Tit">{{ item.title }}</div>
                <!-- <div class="btn">查看详情</div> -->
              </a>
              <router-link
                v-else
                target="_blank"
                :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
              >
                <div class="img">
                  <img
                    class="swiper_img"
                    :src="item.thumb1"
                    style="width: 100%"
                  />
                </div>
                <div class="Tit">{{ item.title }}</div>
                <!-- <div class="btn">查看详情</div> -->
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- <img src="../assets/images/topbanner/1.jpg" alt="" /> -->
      <!-- <a href="/listPic/yiji0007" target="_blank" class="jpmore">查看更多</a> -->
    </div>
    <!-- 党建轮播图 -->
    <!-- <div class="Part2">
      <div class="swiper-container" id="party">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in partyimgList" :key="index"> -->
    <!-- <div v-if="item.urlType == 1">
              <a v-if="!item.url && item.url ==''" >
                <img class="swiper_img" :src="item.fileName" style="width: 100%;">
              </a>
              <a v-else :href="item.url" target="_blank" > 
                <img class="swiper_img" :src="item.fileName" style="width: 100%;">
              </a>
            </div>
            <div v-if="item.urlType != 1 " >
              <a v-if="!item.url && item.url ==''" >
                <img class="swiper_img" :src="item.fileName" style="width: 100%;">
              </a>
              <a v-else :href="item.url" target="_blank" > 
                <img class="swiper_img" :src="item.fileName" style="width: 100%;">
              </a>
            </div> -->
    <!-- <a v-if="!item.url && item.url == ''">
              <img class="swiper_img" :src="item.fileName" style="width: 100%;" />
            </a>
            <a v-else :href="item.url" target="_blank">
              <img class="swiper_img" :src="item.fileName" style="width: 100%;" />
            </a>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-party"></div>
      </div>
    </div> -->
    <!-- 新闻动态第二部分 -->
    <div class="Tpage Part3" id="part3">
      <!-- 新闻内容列表 -->
      <!-- <div class="NewsR">
        <div class="Tit" id="NewsT">
          <div
            class="NewsRInner"
            :class="{ active: activeNewBasic == index }"
            v-for="(item, index) in catalogList2"
            :key="index"
            @mouseenter="mouseenterB2(index)"
          >
            <a :href="item.url"
              >{{ item.title }}
              <img v-if="activeNewBasic == index" src="../assets/img/com_tit_b.png" />
            </a>
          </div>
        </div>

        <div class="ItemList">
          <div class="NewsItem">
            <ul class="comUl" v-if="activeNewBasic == 0">
              <li v-for="(item, index) in activeNewBasic1" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
            <ul class="comUl" v-if="activeNewBasic == 1">
              <li v-for="(item, index) in activeNewBasic2" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
            <ul class="comUl" v-if="activeNewBasic == 2">
              <li v-for="(item, index) in activeNewBasic3" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
      <div class="Noticesannouncements">
        <div class="Noticetop">
          <p>通知公告</p>
          <a href="/list/0246" class="more" style="float: right">+更多</a>
        </div>
        <div class="Noticenewslist">
          <ul>
            <li v-for="(item, index) in newCatalogList02" :key="index">
              <!-- <a :href="item.url">{{ item.title }}</a> -->
              <a
                v-if="item.url && item.url !== ''"
                :href="item.url"
                target="_blank"
                >{{ item.title }}</a
              >
              <router-link
                v-else
                target="_blank"
                :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                >{{ item.title | ellipsis }}
              </router-link>
            </li>
            <!-- <li>
              <a href="#">甘肃第九建设集团有限责任公司 关于202...</a>
            </li>
            <li>
              <a href="#">初心筑梦七十载 匠心善建向未来 建司70...</a>
            </li>
            <li>
              <a href="#">关于开展“十大杰出青年”评选活动的通知</a>
            </li>
            <li>
              <a href="#">甘肃第九建设集团有限责任公司 关于20...</a>
            </li>
            <li>
              <a href="#">疫情防控倡议书</a>
            </li>
            <li>
              <a href="#">关于做好近期疫情防控工作的通知</a>
            </li>
            <li>
              <a href="#">武威市社会保险事业服务中心关于做好202...</a>
            </li>
            <li>
              <a href="#">武威市医疗保障局关于做好医保电子凭证 认...</a>
            </li>
            <li>
              <a href="#">武威市社会保险事业服务中心关于做好202...</a>
            </li>
            <li>
              <a href="#">人力资源部《关于国有企业退休人员管理的指...</a>
            </li>
            <li>
              <a href="#">BIM人才招聘.</a>
            </li>
            <li>
              <a href="#">甘肃第九建设集团公司 关于2020年度医...</a>
            </li> -->
          </ul>
        </div>
      </div>
      <div class="Noticemiddle">
        <div class="Noticemiddletop">
          <div class="Noticetop">
            <p>企业资质</p>
            <a href="/list/0247" class="more" style="float: right">更多+</a>
          </div>
          <div class="Noticenewslist">
            <ul>
              <li v-for="(item, index) in newCatalogList03" :key="index">
                <a
                  v-if="item.url && item.url !== ''"
                  :href="item.url"
                  target="_blank"
                  >{{ item.title }}</a
                >
                <router-link
                  v-else
                  target="_blank"
                  :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                  >{{ item.title | ellipsis2 }}
                </router-link>
              </li>
              <!-- <li>
                <a href="#">建筑装饰装修工程专业承包二级 公路工程施工总承包三级 水利水...</a>
              </li>
              <li>
                <a href="#">管理体系认证证书</a>
              </li>
              <li>
                <a href="#">安全生产许可证</a>
              </li>
              <li>
                <a href="#">建筑工程施工总承包壹级</a>
              </li>
              <li>
                <a href="#">子公司资质</a>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="Noticemiddlebottom">
          <div class="Noticetop">
            <p>党建工作</p>
            <a href="/list/0240" class="more" style="float: right">更多+</a>
          </div>
          <div class="Noticenewslist">
            <ul>
              <li v-for="(item, index) in newCatalogList04" :key="index">
                <a
                  v-if="item.url && item.url !== ''"
                  :href="item.url"
                  target="_blank"
                  >{{ item.title }}</a
                >
                <router-link
                  v-else
                  target="_blank"
                  :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                  >{{ item.title }}
                </router-link>
              </li>
              <!-- <li>
                <a href="#">【项目党建专栏】党建赋能引领项目提质增效</a>
              </li>
              <li>
                <a href="#">【项目党建专栏】党建“铸魂”聚合力 融合“赋能”促发展</a>
              </li>
              <li>
                <a href="#">【项目党建专栏】打造特色项目党建，驱动融合发展“红色引擎”</a>
              </li>
              <li>
                <a href="#">【“三抓三促”行动栏目】九建公司召开项目党建总结会议</a>
              </li>
              <li>
                <a href="#">【主题教育专栏】甘肃九建召开上半年党建工作暨主题教育推进会</a>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="Noticeright">
        <div class="Noticerighttop">
          <p>营业执照</p>
        </div>
        <div class="Noticerightbottom">
          <div class="yyzz">
            <a href="http://gs9j.cn/article/4/9.html">
              <img
                src="../assets/images/yyzz.png"
                style="margin-left: 2px; margin-top: 20px; width: 325px"
              />
            </a>
          </div>
          <div style="margin-top: 20px">
            <select
              style="
                width: 100%;
                height: 30px;
                line-height: 30px;
                padding-left: 5px;
              "
              onchange="window.open(this.options[this.selectedIndex].value)"
            >
              <option>友情链接</option>
              <option value="http://www.gsjtw.cc/">甘肃建投</option>
              <option value="http://www.gsyj.com.cn/">
                甘肃第一建设集团有限责任公司
              </option>
              <option value="http://www.gssanjian.com/w/Default.htm">
                甘肃第三建设集团公司
              </option>
              <option value="http://www.gssjjt.com/">
                甘肃第四建设集团有限责任公司
              </option>
              <option value="http://www.gs5j.com/">甘肃第五建设集团公司</option>
              <option value="http://www.gsljw.com/">
                甘肃第六建设集团股份有限公司
              </option>
              <option value="http://www.gs7j.com.cn/">
                甘肃第七建设集团股份有限公司
              </option>
              <option value="http://www.gs8j.com/">
                甘肃第八建设集团有限责任公司
              </option>
            </select>
          </div>
          <div class="mapbottom">
            <div class="mapCon">
              <baidu-map
                style="width: 314px; height: 180px"
                @ready="mapReady"
                id="baiduMap"
                :scroll-wheel-zoom="true"
                :zoom="17"
                center="甘肃第九建设集团公司"
              >
                <!-- 地址搜索框 -->
                <bm-city-list
                  class="suoui"
                  anchor="BMAP_ANCHOR_TOP_LEFT"
                ></bm-city-list>
                <bm-marker
                  :position="point"
                  :dragging="true"
                  animation="BMAP_ANIMATION_BOUNCE"
                >
                </bm-marker>
                <!-- 缩放控件 -->
                <bm-navigation
                  anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                ></bm-navigation>
                <!-- 地图类型 -->
                <bm-map-type
                  :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
                  anchor="BMAP_ANCHOR_TOP_RIGHT"
                ></bm-map-type>
                <!-- <bm-panorama></bm-panorama> -->
                <bm-geolocation
                  anchor="BMAP_ANCHOR_BOTTOM_LEFT"
                  :showAddressBar="true"
                  :autoLocation="true"
                ></bm-geolocation>
              </baidu-map>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻列表图片轮播图 -->
      <!-- <div class="NewsL">
        <div id="newsFlashItem" style="width:100%; overflow:hidden;">
          <div class="flashImg" style="display: block;">
            <div class="flashImg-container swiper-container" id="newsFlash22">
              <div class="flashImg-wrapper swiper-wrapper">
                <div class="flashImg-slide swiper-slide" v-for="(item, index) in flashImgList22" :key="index">
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 100% ;" />
                    <div class="txt">
                      <p class="txtTitle">{{ item.title }}</p>
                    </div>
                  </a>
                  <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" target="_blank">
                    <img class="swiper_img" :src="item.thumb1" style="width: 100% ; height: 100% ;" />
                    <div class="txt">
                      <p class="txtTitle">{{ item.title }}</p>
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination flashImg-pagin"></div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div class="clear"></div> -->
    <!-- <div class="Part4">
      <div class="Tpage">
        <a href=""><img src="../assets/img/p31.png" /> </a>
        <a href="" class="tpageImg"><img src="../assets/img/p32.png" /> </a>
        <a href="/report" class="tpageImg" target="_blank"><img src="../assets/img/jb11.png" /> </a>
      </div>
    </div> -->
    <!-- <div class="clear"></div> -->
    <!-- 新闻动态第三部分 -->
    <!-- <div class="Tpage Part5" id="part5"> -->
    <!-- 视频 -->
    <!-- <div class="NewsL">
        <video
          class="groupVideo"
          controls=""
          preload="none"
          src="../assets/img/yjnewvideo231024.mp4"
          muted=""
          poster="../assets/img/video.jpg"
          style="width: 100%; height: 100%;"
        >
          <source src="../assets/img/yjnewvideo231024.mp4" type="video/mp4" />
        </video>
      </div> -->

    <!-- 新闻内容列表第三部分 -->
    <!-- <div class="NewsR">
        <div class="Tit" id="NewsT">
          <div
            class="NewsRInner"
            :class="{ active: activeNewStudy == index }"
            v-for="(item, index) in catalogList3"
            :key="index"
            @mouseenter="mouseenterStudy(index)"
          >
            <a :href="item.url"
              >{{ item.title }}
              <img v-if="activeNewStudy == index" src="../assets/img/com_tit_b.png" />
            </a>
          </div>
        </div>
        <div class="ItemList">
          <div class="NewsItem">
            <ul class="comUl" v-if="activeNewStudy == 0">
              <li v-for="(item, index) in activeNenStu01" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
            <ul class="comUl" v-if="activeNewStudy == 1">
              <li v-for="(item, index) in activeNenStu02" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <span>
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                    <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                      >{{ item.title }}
                    </router-link>
                  </span>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
            <ul class="comUl" v-if="activeNewStudy == 2">
              <li v-for="(item, index) in activeNenStu03" :key="index">
                <div>
                  <img src="../assets/img/li.png" />
                  <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank">{{ item.title }}</a>
                  <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"
                    >{{ item.title }}
                  </router-link>
                  <span class="span">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div> -->
    <!-- 精品项目轮播图 -->
    <!-- <div class="Tpage Part6">
      <div class="tit">
        <div class="b">
          精品展示
        </div>
      </div>
      <div class="main_panel" id="Jpgc">
        <div class="JpgcSwiper-container swiper-container" id="jpgcPhoto">
          <div class="JpgcSwiper-wrapper swiper-wrapper">
            <div class="JpgcSwiper-slide swiper-slide" v-for="(item, index) in JpgcPlayList" :key="index">
              <a :href="item.url" v-if="item.url && item.url !== ''" class="JpItem" target="_blank">
                <div class="img">
                  <img class="swiper_img" :src="item.thumb1" style="width: 100%; " />
                </div>
                <div class="Tit">{{ item.title }}</div>
                <div class="btn">查看详情</div>
              </a>
              <router-link v-else target="_blank" :to="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                <div class="img">
                  <img class="swiper_img" :src="item.thumb1" style="width: 100%; " />
                </div>
                <div class="Tit">{{ item.title }}</div>
                <div class="btn">查看详情</div>
              </router-link>
            </div>
          </div>
        </div>
      </div> -->
    <!-- <img src="../assets/images/topbanner/1.jpg" alt="" /> -->
    <!-- <a href="/listPic/yiji0007" target="_blank" class="jpmore">查看更多</a>
    </div> -->
  </div>
</template>

<script>
import Swiper from "swiper";
import homeBanner from "@/components/swiper.vue";
import {
  articles,
  getTopArtList,
  picArticles,
  getAdvert,
  getAllArtListByParentUuid,
  getPageInfo,
  picArticlesRecommend
} from "@/api/common";
export default {
  components: {
    homeBanner,
  },
  data() {
    return {
      point: "",
      zoom: 18,
      markerIcon: "", //标注图片
      activeNewsJt: 0,
      activeNewBasic: 0,
      activeNewStudy: 0,
      active: 0,
      ismouseover: true,
      nav1On: 0,
      jtNewsList: [],
      nav1: [
        {
          title: "集团新闻",
          url: "/list/02370001",
        },
        {
          title: "建投要闻",
          url: "/list/0238",
        },
      ],
      //第一个新闻列表
      newCatalogList01: [],
      newCatalogList02: [],
      newCatalogList03: [],
      newCatalogList04: [],
      // 第二个新闻列表
      activeNewBasic2: [],
      activeNewBasic1: [],
      activeNewBasic3: [],
      // 第三个新闻列表
      activeNenStu01: [],
      activeNenStu02: [],
      activeNenStu03: [],

      newsFlashList01: [],
      JpgcPlayList: [
        // {
        //   thumb1: require('../assets/images/gongchengbanner/1.png'),
        //   title: '喜报！九建家属院棚户区改造建设项目（一期）顺利获批施工许可证'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/2.png'),
        //   title: '【“三抓三促”行动栏目】鲜花云溪（金昌市花卉产业示范园）一期建设项目顺利通过“九建杯”现场复查'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/3.jpg'),
        //   title: '张掖750kV变电站新建工程'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/4.png'),
        //   title: '鲜花云溪（花卉产业示范园）项目'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/5.png'),
        //   title: '武威义乌商贸城'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/6.png'),
        //   title: '中广核甘肃民勤风力发电有限公司'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/7.jpg'),
        //   title: '武威市南苑商业综合楼获飞天奖'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/8.jpg'),
        //   title: '武威市体育场建设项目'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/9.jpg'),
        //   title: '武威市第一中学迁建提升工程项目'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/10.png'),
        //   title: '武威市凉州区公安局办公楼'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/11.png'),
        //   title: '武威工商银行综合楼'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/12.jpg'),
        //   title: '武威市“江南华庭3#商住楼”获飞天奖'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/13.jpg'),
        //   title: '停车场'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/14.jpg'),
        //   title: '停车场'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/15.png'),
        //   title: '青海西宁新闻大厦'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/16.jpg'),
        //   title: '神州荒漠野生动物园改扩项目第一标段2'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/17.png'),
        //   title: '内蒙古阿拉善右旗党政办公大楼'
        // },
        // {
        //   thumb1: require('../assets/images/gongchengbanner/18.jpg'),
        //   title: '凉州区金羊镇三盘磨片区湿地农民棚户区改造安置房建设项目'
        // }
      ],
      //新闻列表轮播图
      flashImgList: [],
      //两个新闻图片的轮播
      flashImgList11: [
        { img: require("../assets/images/newsbanner/1.jpg") },
        { img: require("../assets/images/newsbanner/2.jpg") },
        { img: require("../assets/images/newsbanner/3.jpg") },
        { img: require("../assets/images/newsbanner/4.jpg") },
        { img: require("../assets/images/newsbanner/5.jpg") },
        { img: require("../assets/images/newsbanner/6.png") },
      ],
      flashImgList22: [],
      //新闻目录一
      catalogList: [
        {
          id: 1,
          url: "/list/02370001",
          title: "集团新闻",
        },
        {
          id: 2,
          url: "/list/yiji00020002",
          title: "建投要闻",
        },
        {
          id: 3,
          url: "/list/yij3",
          title: "党群工作",
        },
        {
          id: 4,
          url: "/list/yiji00020005",
          title: "媒体聚焦",
        },
      ],
      //党建轮播图
      partyimgList: [],
      //新闻目录二
      catalogList2: [
        {
          id: 1,
          url: "/list/yiji00020003",
          title: "基层动态",
        },
        {
          id: 2,
          url: "/list/yiji000600020001",
          title: "招标公告",
        },
        {
          id: 3,
          url: "/list/yiji00020004",
          title: "行业动态",
        },
      ],
      //新闻目录三
      catalogList3: [
        {
          id: 1,
          url: "/list/yij5",
          title: "学习园地",
        },
        {
          id: 2,
          url: "/list/yiji00040003",
          title: "职工文苑",
        },
        {
          id: 3,
          url: "/list/yiji00040001",
          title: "一建之声",
        },
      ],
      newsTextList: [],
      newslist1: [
        {
          topTxt: "12-13",
          bottomTxt: "2023",
          url: "https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514333&amp;idx=1&amp;sn=6b02d00abb67c594c3c5117c83f0de3c&amp;chksm=ec019f57db761641062ff141fe5452503b5cc35f8ead0ab61a6630efb0df81b292b094c4ab91&amp;token=1734539789&amp;lang=zh_CN#rd",
          title:
            "【宪法宣传栏目】安全质量警钟长鸣，法制教育常抓不懈——张掖分公司...",
        },
        {
          topTxt: "12-13",
          bottomTxt: "2023",
          url: "https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514360&amp;idx=1&amp;sn=9cb0052c1e386ed4e95b971e29da3bfd&amp;chksm=ec019f72db7616648b0c5a67ff7e0bab29bda338dc5bdf2fbc7c359c749c74f64d202a666e9a&amp;token=1734539789&amp;lang=zh_CN#rd",
          title:
            "【项目党建专栏】夯实堡垒聚合力 党建领航促发展——三公司推动党建...",
        },
        {
          topTxt: "12-13",
          bottomTxt: "2023",
          url: "https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514360&amp;idx=2&amp;sn=390bba69fdacd1a916d2fedcac39a515&amp;chksm=ec019f72db7616646ee4ec19025032170eb5bad9dedbb4ad006da772bca4ed1fe441860594df&amp;token=1734539789&amp;lang=zh_CN#rd",
          title: "【支部共建栏目】开讲啦！这场讲座干货满满",
        },
        {
          topTxt: "12-11",
          bottomTxt: "2023",
          url: "https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514211&amp;idx=1&amp;sn=cc7778ee9322ed25c4d56b31f8311281&amp;chksm=ec019fe9db7616ffbc3bd025376cb34a8b1a48fe0701b12e29ece259bb8f40d1432f12d7a8cf&amp;token=542266017&amp;lang=zh_CN#rd",
          title:
            "【宪法宣传栏目】大力弘扬宪法精神，建设社会主义法治文化——三公司...",
        },
        {
          topTxt: "12-11",
          bottomTxt: "2023",
          url: "https://mp.weixin.qq.com/s?__biz=MzI5MjMwMzU4OQ==&amp;mid=2247514211&amp;idx=2&amp;sn=b9ea2aa2cae03f69cae470cb0f7f91b8&amp;chksm=ec019fe9db7616ff3dc173ea6296df8676e17d14112cdef97d015b41d2494dc9f55f2ca441db&amp;token=542266017&amp;lang=zh_CN#rd",
          title:
            "【宪法宣传栏目】弘扬宪法精神 维护宪法权威——盛久基业党支部开展...",
        },
      ],
      newslist2: [
        {
          title: "平台公约",
          url: "",
        },
        {
          title: "甘肃第九建设集团有限责任公司 关于202...",
          url: "",
        },
        {
          title: "初心筑梦七十载 匠心善建向未来 建司70...",
          url: "",
        },
        {
          title: "关于开展“十大杰出青年”评选活动的通知",
          url: "",
        },
        {
          title: "甘肃第九建设集团有限责任公司 关于20...",
          url: "",
        },
        {
          title: "疫情防控倡议书",
          url: "",
        },
        {
          title: "关于做好近期疫情防控工作的通知",
          url: "",
        },
        {
          title: "武威市社会保险事业服务中心关于做好202...",
          url: "",
        },
        {
          title: "武威市医疗保障局关于做好医保电子凭证 认...",
          url: "",
        },
        {
          title: "武威市社会保险事业服务中心关于做好202...",
          url: "",
        },
        {
          title: "人力资源部《关于国有企业退休人员管理的指...",
          url: "",
        },
        {
          title: "BIM人才招聘",
          url: "",
        },
        {
          title: "甘肃第九建设集团公司 关于2020年度医...",
          url: "",
        },
      ],
      // newCatalogList03: [
      //   {
      //     title: '市政公用工程施工总承包二级 起重设备安装工程专业承包二级 钢...',
      //     url: ''
      //   },
      //   {
      //     title: '建筑装饰装修工程专业承包二级 公路工程施工总承包三级 水利水...',
      //     url: ''
      //   },
      //   {
      //     title: '管理体系认证证书',
      //     url: ''
      //   },
      //   {
      //     title: '安全生产许可证',
      //     url: ''
      //   },
      //   {
      //     title: '建筑工程施工总承包壹级',
      //     url: ''
      //   },
      //   {
      //     title: '子公司资质',
      //     url: ''
      //   }
      // ],
      newslist4: [
        {
          title:
            "【项目党建专栏】夯实堡垒聚合力 党建领航促发展——三公司推动党建...",
          url: "",
        },
        {
          title: "【项目党建专栏】党建赋能引领项目提质增效",
          url: "",
        },
        {
          title: "【项目党建专栏】党建“铸魂”聚合力 融合“赋能”促发展",
          url: "",
        },
        {
          title: "【项目党建专栏】打造特色项目党建，驱动融合发展“红色引擎”",
          url: "",
        },
        {
          title: "【“三抓三促”行动栏目】九建公司召开项目党建总结会议",
          url: "",
        },
        {
          title: "【主题教育专栏】甘肃九建召开上半年党建工作暨主题教育推进会",
          url: "",
        },
      ],
    };
  },
  mounted() {
    this.bannerJpgc();
    this.getTopArtList();
    this.newsCatalog();
    this.picArticles();
    this.bannerImg();
    this.jtNews();
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function (value) {
      if (!value) return "";
      if (value.length > 22) {
        return value.slice(0, 22) + "...";
      }
      return value;
    },
    ellipsis2: function (value) {
      if (!value) return "";
      if (value.length > 50) {
        return value.slice(0, 50) + "...";
      }
      return value;
    },
  },
  methods: {
    addnav1Css(index) {
      this.nav1On = index;
    },
    mapReady({ BMap, map }) {
      // 选择一个经纬度作为中心点
      console.log(BMap, map);
      this.point = new BMap.Point(102.648417, 37.918926);
      this.zoom = 18;
      map.centerAndZoom(this.point, 12);
    },
    mouseenterNewsJt(val) {
      this.activeNewsJt = val;
    },
    mouseenterB2(val) {
      this.activeNewBasic = val;
    },
    mouseenterStudy(val) {
      this.activeNewStudy = val;
    },
    // 党建轮播
    bannerImg() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        advertType: 3,
      };
      getAdvert(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.partyimgList = data;
          this.$nextTick(() => {
            new Swiper("#party", {
              effect: "fade",
              loop: true,
              speed: 300,
              autoplay: 3000,
              updateOnImagesReady: true,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false,
              pagination: ".swiper-pagination-party",
              paginationClickable: true,
            });
          });
        }
      });
    },
    jtNews() {
      var _this = this;
      let data1 = {
        // channelUuid: "01150003",  // 集团要闻
        channelUuid: "00190001",
        entTApplicationUuid: _this.webIdGroup,
        pageNum: 1,
        pageSize: 5,
      };
      articles(data1).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.jtNewsList = data.rows;
        }
      });
    },
    //精品工程轮播图
    bannerJpgc() {
      var _this = this;
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: "0245",
        pageNum: 1,
        pageSize: 10,
      };
      picArticles(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.JpgcPlayList = data.rows;
          this.$nextTick(() => {
            this.swiper = new Swiper("#jpgcPhoto", {
              autoplay: 1,
              loop: true,
              speed: 8000,
              updateOnImagesReady: true,
              slidesPerView: 4,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
            });
          });
        }
      });
    },

    getTopArtList() {
      var _this = this;
      let data = {
        applicationUuid: this.webId,
      };
      getTopArtList(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.newsTextList = data;
        }
      });
    },

    // 新闻动态-右
    newsCatalog() {
      var _this = this;

      // 集团新闻
      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "0237",
        pageNum: 1,
        pageSize: 5,
      };
      getPageInfo(data01).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.newCatalogList01 = data.rows;
        }
      });

      // 建投要闻  ---通知公告
      let data02 = {
        entTApplicationUuid: _this.webId,
        // channelUuid: 'yiji00020002',
        channelUuid: "0246",
        pageNum: 1,
        pageSize: 13,
      };
      getPageInfo(data02).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.newCatalogList02 = data.rows;
        }
      });

      // 企业资质
      let data03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "0247",
        pageNum: 1,
        pageSize: 20,
      };
      articles(data03).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.newCatalogList03 = data.rows;
        }
      });

      //党建工作
      let data04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "0240",
        pageNum: 1,
        pageSize: 6,
      };
      articles(data04).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.newCatalogList04 = data.rows;
        }
      });

      //动态新闻第二部分
      //基层动态
      let data05 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "yiji00020003",
        pageNum: 1,
        pageSize: 8,
      };
      articles(data05).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.activeNewBasic1 = data.rows;
        }
      });
      // 招标公告
      let data06 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "yiji00060002",
        pageNum: 1,
        pageSize: 8,
      };
      getAllArtListByParentUuid(data06).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.activeNewBasic2 = data.rows;
        }
      });
      //行业动态
      let data07 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "yiji00020004",
        pageNum: 1,
        pageSize: 8,
      };
      articles(data07).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.activeNewBasic3 = data.rows;
        }
      });

      //动态新闻第三部分
      //学习园地
      let data08 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "yiji0005",
        pageNum: 1,
        pageSize: 8,
      };
      articles(data08).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.activeNenStu01 = data.rows;
        }
      });

      //职工文苑
      let data09 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "yiji00040003",
        pageNum: 1,
        pageSize: 8,
      };
      articles(data09).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.activeNenStu02 = data.rows;
        }
      });

      //一建之声
      let datab = {
        entTApplicationUuid: _this.webId,
        channelUuid: "yiji00040001",
        pageNum: 1,
        pageSize: 8,
      };
      articles(datab).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.activeNenStu03 = data.rows;
        }
      });
    },
    // 新闻轮播图
    picArticles() {
      var _this = this;

      //新闻第一部分轮播图
      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "0244",
        pageNum: 1,
        pageSize: 5,
      };
      // picArticles(data01).then((res) => {
      picArticlesRecommend(data01).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.flashImgList11 = data.rows;
          this.$nextTick(() => {
            new Swiper("#newsFlash", {
              loop: true,
              autoplay: 3000,
              speed: 200,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              effect: "fade",
              pagination: ".swiper-pagination",
              paginationClickable: true,
              paginationBulletRender: function (swiper, index, className) {
                return (
                  '<span class="' + className + '">' + (index + 1) + "</span>"
                );
              },
            });
          });
        }
      });

      //新闻第三部分轮播图 （第2个轮播图）
      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: "yiji00020003",
        pageNum: 1,
        pageSize: 5,
      };
      picArticles(data02).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.flashImgList22 = data.rows;
          this.$nextTick(() => {
            new Swiper("#newsFlash22", {
              loop: true,
              autoplay: 3000,
              speed: 200,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              effect: "fade",
              pagination: ".swiper-pagination",
              paginationClickable: true,
              paginationBulletRender: function (swiper, index, className) {
                return (
                  '<span class="' + className + '">' + (index + 1) + "</span>"
                );
              },
            });
          });
        }
      });
    },
  },
};
</script>

<style>
.homePage {
  width: 100%;
  height: auto;
  overflow: hidden;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, \5fae\8f6f\96c5\9ed1,
    Tahoma, Arial, sans-serif;
}
.Newstop {
  width: 1200px;
  height: 68px;
  overflow: hidden;
  position: absolute;
  top: -68px;
  left: 0;
  background-color: #fff;
  z-index: 2;
}
.Newstoptitle {
  width: 595px;
  height: 52px;
  float: left;
  /* margin-top: 10px; */
  font-size: 18px;
  border-bottom: 1px solid #d6d6d6;
}
.Newstoptitle p {
  line-height: 52px;
  color: #0062b2;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}
.Newstopright {
  width: 545px;
  height: 52px;
  float: right;
  /* margin-top: 10px; */
  border-bottom: 1px solid #d6d6d6;
}
.Newstopright div {
  width: 140px;
  height: 52px;
  line-height: 52px;
  display: inline-block;
  /* float: left; */
}
.Newstopright div a {
  width: 100%;
  height: 100%;
  line-height: 52px;
  text-align: center;
  /* background: #0062b2; */
  /* color: white; */
  float: left;
  font-weight: bold;
  font-size: 18px;
}
.nav1OnCss {
  background: #0062b2;
  color: white;
  /* border-bottom: 4px #0062b1 solid; */
}
/* //hot */
/* .TTouTiao {
  width: 1200px;
  margin: 0 auto;
  height: 85px;
  margin-top: 10px;
  overflow: hidden;
  background: url(../assets/img/hot.png) left center no-repeat;
}
.TTouTiao .Tl {
  width: 81px;
  height: 85px;
  float: left;
}
.TTouTiao .Tr {
  width: 1100px;
  float: right;
}
.TTouTiao .Tr a {
  width: 100%;
  height: 85px;
  display: block;
  line-height: 85px;
  text-align: center;
  color: #000000;
  font-size: 28px;
  font-weight: bolder;
} */

/* 新闻部分 */
.inList li .l_Date {
  width: 60px;
  height: 60px;
  background: #0062b2;
  float: left;
}
.inList li .l_Date .topTxt {
  height: 30px;
  line-height: 30px;
  color: white;
  text-align: center;
  font-size: 14px;
  border-bottom: 1px solid white;
}
.inList li .l_Date .bottomTxt {
  height: 30px;
  line-height: 30px;
  color: white;
  text-align: center;
  font-size: 16px;
}
.inList li .r_news {
  width: 485px;
  height: 60px;
  float: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.inList li .r_news a {
  margin-left: 20px;
  color: #333;
  line-height: 60px;
  font-size: 14px;
}
.inList li {
  height: 60px;
  margin-bottom: 18px;
}
/*  */
/*  */
/* // 新闻动态部分 */
.homePage .Part1 {
  height: 385px;
  position: relative;
  z-index: 999;
}

.homePage .NewsL {
  width: 585px;
  height: 375px;
  overflow: hidden;
  float: left;
  margin-left: 10px;
}

.homePage .NewsL .flashImg {
  width: 100%;
  float: left;
  position: relative;
  height: 360px;
}
.homePage .NewsL .flashImg-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.homePage .NewsL .flashImg-slide {
  height: 100%;
  width: 100%;
}
.homePage .NewsL .flashImg-slide .swiper_img {
  height: 100%;
  width: 100%;
}
.homePage .NewsL .flashImg .flashImg-slide .txt {
  width: 100%;
  height: 34px;
  overflow: hidden;
  background-color: #000000;
  margin-top: -34px;
  z-index: 2;
  opacity: 0.7;
}
.homePage .NewsL .flashImg .txt .txtTitle {
  font-size: 12px;
  line-height: 34px;
  color: #ffffff;
  margin: 0 auto;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  width: 70%; /*需要配合宽度来使用*/
  margin-left: 2px;
  font-family: "微软雅黑", "宋体";
}
.homePage .NewsL .swiper-pagination {
  position: absolute;
  text-align: right;
  z-index: 99;
  bottom: 8px;
}
.homePage .NewsL .swiper-pagination-bullet {
  position: relative;
  width: 15px;
  height: 15px;
  margin: 0px 5px;
  color: #000000;
  font: 12px/15px "\5B8B\4F53";
  text-decoration: none;
  text-align: center;
  outline: 0;
  background: #cbcbcb;
  z-index: 99;
  border-radius: 0;
}
.homePage
  .flashImg
  .NewsL
  .flashImg-pagin
  .swiper-container-horizontal
  > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 8px;
  width: 100%;
}
.homePage .NewsL .swiper-pagination-bullet-active {
  background: #bc2d1c;
  color: #fff;
}
/* //新闻列表部分 */
.homePage .NewsR {
  width: 545px;
  height: 372px;
  float: right;
}

.homePage .NewsR .Tit {
  width: 100%;
  height: 43px;
  /* // overflow: hidden; */
  float: left;
}
.homePage .NewsR .Tit a {
  width: 115px;
  height: 43px;
  float: left;
  margin-right: 10px;
  display: block;
  text-align: center;
  line-height: 38px;
  color: #0062b3;
  font-size: 14px;
  font-weight: bolder;
  float: left;
}
/* // 精品项目轮播图 */
.homePage .Part6 {
  height: 320px;
  overflow: hidden;
  background-size: cover;
}
.Part6 .tit {
  width: 100%;
  overflow: hidden;
  height: 52px;
  line-height: 52px;
  border-bottom: 1px solid #d6d6d6;
}
.Part6 .tit .b {
  width: 200px;
  color: #0062b2;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
  float: left;
}
/* 轮播图展示 */
.more {
  color: #666;
  float: right;
  font-size: 14px;
  font-weight: bold;
}
.more:hover {
  color: #0062b2;
}
/* 21223243454643654476765787868 */
.Noticesannouncements {
  width: 335px;
  height: 625px;
  float: left;
}
.Noticetop {
  height: 52px;
  line-height: 52px;
  color: #0062b2;
  font-size: 18px;
  border-bottom: 1px solid #d6d6d6;
  font-weight: bold;
}
.Noticetop p {
  width: 72px;
  margin-left: 10px;
  float: left;
}
.Noticenewslist li {
  width: 495px;
  background: url(../assets/images/news.jpg) no-repeat left center;
  height: 40px;
  line-height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Noticenewslist li a {
  float: left;
  margin-left: 10px;
  color: #666;
  font-size: 14px;
}
.Noticemiddle {
  width: 495px;
  height: 625px;
  float: left;
  margin-left: 20px;
}
.Noticemiddletop {
  width: 495px;
  height: 312.5px;
}
.Noticemiddlebottom {
  width: 495px;
  height: 312.5px;
}
.Noticeright {
  width: 330px;
  height: 625px;
  float: left;
  margin-left: 20px;
}
.Noticerighttop {
  height: 52px;
  line-height: 52px;
  background: #0062b2;
  font-size: 18px;
  color: #fff;
  font-weight: bold;
}
.Noticerighttop p {
  margin-left: 10px;
}
.yyzz {
  width: 330px;
  height: 295px;
  border: 1px solid #d6d6d6;
}
.mapbottom {
  width: 330px;
  height: 180px;
}
.mapCon {
  width: 314px;
  height: 180px;
}
a,
a:focus,
a:hover {
  text-decoration: none;
}
.homePage .NewsR .Tit a:hover {
  color: #fff;
  background-color: #0062b3;
}
.homePage .NewsR .Tit img {
  display: none;
  margin-top: 5px;
  margin-left: 50px;
}
.homePage .NewsR .Tit a:hover img {
  display: block;
}

.homePage .NewsR .ItemList {
  width: 100%;
  overflow: hidden;
  padding-top: 10px;
  clear: both;
}
.homePage .NewsR .ItemList .comUl {
  padding: 0px;
  margin: 0px;
}
.homePage .NewsR .ItemList .comUl li {
  width: 100%;
  height: 38px;
  line-height: 38px;
  /* // background: url(../../assets/img/li.png) 10px center no-repeat; */
  margin: 0 auto;
  border-bottom: 1px #a4a4a4 dotted;
}
.homePage .NewsR .ItemList .comUl li img {
  float: left;
  margin-top: 15px;
  margin-right: 16px;
}
.homePage .NewsR .ItemList .comUl li a {
  float: left;
  /* // text-indent: 2em; */
  white-space: nowrap;
  display: contents;
  text-align: left;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
  margin-top: 8px;
  display: block;
  font: 14px Helvetica Neue, Helvetica, PingFang SC, \5fae\8f6f\96c5\9ed1,
    Tahoma, Arial, sans-serif;
}

.homePage .NewsR .ItemList .NewsItem .comUl li a:hover {
  animation: newshov 0.3s linear 1;
  color: #a2a6aa;
}
@keyframes newshov {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(-6px);
  }
}
.homePage .NewsR .comUl li .span {
  float: right;
  font-size: 14px;
}
.clear {
  width: 100%;
  height: 20px;
  overflow: hidden;
  display: block;
  clear: both;
}
/* //党建轮播图 */
.Part2 {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.homePage .Part2 .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;
}
.homePage .Part2 .swiper-container {
  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      height: auto;
    }
  }
}
.Part2 .swiper-pagination {
  text-align: right;
}

.homePage .Part2 .swiper-pagination-bullet-active {
  opacity: 1;
  background: #5599e4;
}

.homePage .Part2 .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 100%;
}

/* // 新闻第二部分 */

.homePage .Part3 {
  height: 625px;
  margin-top: 10px;
}

.homePage .Part3 .NewsR {
  width: 640px;
  height: 360px;
  float: left;
}
.homePage .Part3 .NewsL {
  width: 535px;
  height: 360px;
  overflow: hidden;
  float: right;
}
.homePage .Part4 {
  width: 100%;
  overflow: hidden;
  height: 210px;
  background: url(../assets/img/p3.jpg);
  background-size: cover;
}
.Tpage {
  width: 1200px;
  margin: 0px auto;
}
.Part4 a {
  width: 378px;
  height: 147px;
  display: block;
  float: left;
  margin-top: 24px;
}
.Part4 .tpageImg {
  margin-left: 33px;
}
.homePage .Part4 img {
  display: inline-block;
  border: none;
}

/* //第五部分 */
.homePage .Part5 {
  height: 366px;
  margin-top: 10px;
}
.homePage .Part5 .Left {
  width: 535px;
  height: 360px;
  overflow: hidden;
  float: left;
}

/* ***8**8*****8** */
#Jpgc {
  height: 290px;
  overflow: hidden;
  width: 100%;
  padding-bottom: 10px;
  margin-top: 20px;
}

.homePage .Jpgcw .main_panel {
  margin: 0 auto;
  overflow: hidden;
  width: 1200px;
}
.homePage .jpmore {
  width: 100px;
  height: 36px;
  background-color: #e8e9ee;
  display: block;
  color: #6e706d;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  margin: 0 auto;
  border-radius: 3px;
  opacity: 0.7;
}
#Jpgc .JpgcSwiper-container .swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  box-sizing: content-box;
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
#Jpgc .JpgcSwiper-container .swiper-slide {
  width: 283px;
  height: 365px;
  overflow: hidden;
  margin-left: 20px;
  float: left;
  text-align: center;
}

#Jpgc .JpItem {
  width: 283px;
  height: 365px;
  display: block;
  overflow: hidden;
  text-align: center;
  float: left;
}

#Jpgc #jpgcPhoto .JpgcSwiper-wrapper .JpgcSwiper-slide a .img img {
  width: 283px;
  height: 197px;
}
#Jpgc #jpgcPhoto .JpgcSwiper-wrapper .JpgcSwiper-slide a .Tit {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #424242;
  margin: 5px 0px;
  font-weight: bolder;
  font-size: 13px;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
  width: 90%; /*需要配合宽度来使用*/
}
#Jpgc #jpgcPhoto .JpgcSwiper-wrapper .JpgcSwiper-slide a .btn {
  width: 124px;
  height: 30px;
  border: 1px #ec0404 solid;
  line-height: 30px;
  color: #ec0404;
  margin: 10px auto 0px auto;
  font-size: 13px;
}
.homePage .NewsRInner.active a {
  color: #fff;
  background-color: #0062b3;
}
.homePage .NewsR .Tit img {
  display: block;
}

#Jpgc .swiper-container .swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
#jpgcPhoto {
  .swiper-button-next {
    right: auto;
  }
}

.homePage .Links .P3 .nr .link-container .swiper-slide {
  height: 30px;
}
</style>
